import { Box, IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { colors, spacing, typography } from "../../../../../../../../../assets/styles/tokens";

interface ViewingPaginationProps {
  total?: number;
  pageSize?: number;
  page?: number; // 0-based, controlled by parent
  onPageChange?: (page: number) => void;
}

export default function BudgetControlGraphPagination({
  total = 0,
  pageSize = 5,
  page = 0,
  onPageChange,
}: ViewingPaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const current = Math.min(page, totalPages - 1);
  const from = total === 0 ? 0 : current * pageSize + 1;
  const to = Math.min((current + 1) * pageSize, total);

  const handlePrev = () => onPageChange?.(Math.max(0, current - 1));
  const handleNext = () => onPageChange?.(Math.min(totalPages - 1, current + 1));

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent:'center',
        alignItems: "center",
        py:spacing.Spacing.md1.$value
      }}
    >
      {/* Prev button */}
      <IconButton
        onClick={handlePrev}
        disabled={current === 0}
        size="small"
        sx={{
          color: current === 0 ? colors.GrayLightMode[500].$value : colors.GrayLightMode[700].$value,
          "&:hover": { backgroundColor: "transparent", color: colors.GrayLightMode[500].$value },
          p: 0.5,
        }}
      >
        <ChevronLeftIcon sx={{ fontSize: 18 }} />
      </IconButton>

      {/* Label */}
      <Box sx={{ textAlign: "center", minWidth: 72 }}>
        <Typography
          sx={{
            fontSize: typography.Size.Text.xs.$value,
            fontWeight: typography.Font_weight.Regular.$value,
            color: colors.GrayLightMode[500].$value,
          }}
        >
          Viewing
        </Typography>
        <Typography
          sx={{
             fontSize: typography.Size.Text.xs.$value,
            fontWeight: typography.Font_weight.Regular.$value,
            color: colors.GrayLightMode[500].$value,
          }}
        >
          {from}–{to} of {total}
        </Typography>
      </Box>

      {/* Next button */}
      <IconButton
        onClick={handleNext}
        disabled={current >= totalPages - 1}
        size="small"
        sx={{
          color: current >= totalPages - 1 ? colors.GrayLightMode[500].$value : colors.GrayLightMode[700].$value,
          "&:hover": { backgroundColor: "transparent", color: colors.GrayLightMode[500].$value },
          p: 0.5,
        }}
      >
        <ChevronRightIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );
}